export enum VehicleOrderDirection {
  Ascending = 'asc',
  Descending = 'desc',
}
